var _circle, _circle2, _ellipse, _circle3, _ellipse2, _circle4, _ellipse3, _circle5, _circle6, _ellipse4, _circle7, _ellipse5, _ellipse6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatasetsColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "#D830F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 21,
    cy: 12,
    r: 3,
    fill: "#D830F9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 12,
    cy: 2,
    rx: 2,
    ry: 2,
    fill: "#D830F9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 12,
    cy: 22,
    r: 2,
    fill: "#D830F9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 3,
    cy: 12,
    rx: 3,
    ry: 3,
    fill: "#D830F9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 3.5,
    cy: 3.5,
    r: 1.5,
    fill: "#D830F9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 20.5,
    cy: 3.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#D830F9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.5,
    cy: 20.5,
    r: 1.5,
    fill: "#D830F9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 17,
    cy: 17.0001,
    r: 2,
    fill: "#D830F9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 7.5,
    cy: 16.5001,
    rx: 1.5,
    ry: 1.5,
    fill: "#D830F9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 7,
    cy: 7,
    r: 2,
    fill: "#D830F9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 16.5,
    cy: 7.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#D830F9"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 3.5,
    cy: 20.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#D830F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetsColor);
export default __webpack_public_path__ + "static/media/datasets-color.1a614818ae3ec05e359d27e7cebd23fa.svg";
export { ForwardRef as ReactComponent };